import styles from "./styles";
import global from "../../styles";
import PropTypes from "prop-types";
import JoinNow from "../join-now";
import ExploreBenefits from "../explore-benefits";
import TsAndCs from "../tsAndCs";
import classNames from "classnames";
import AsosWorldLogo from "../../assets/asos-world-logo.svg";
import Decoration from "../decoration";
import { formatHeaderWords } from "../../helpers/formatHeaderWords";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";

const Connect = ({ currentTierId, assetsUrl, isAnonymous }) => {
  const translate = useTranslate(useLocaleProvider());
  const header = translate("loyalty_landing_page_intro_header");
  const headerFormatted = formatHeaderWords(header);
  const scrollToNextSection = () => {
    const nextSection = document.getElementById("benefitsLevelUpContainer");
    nextSection.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };
  return (
    <div className={styles.connectImageContainer}>
      <picture className={styles.connectImage}>
        <source
          srcSet={`${assetsUrl}/dWeb-Connect_SS25_kgg07o`}
          media="(min-width: 480px)"
          width="100%"
        />
        <img
          src={`${assetsUrl}/mWeb-Connect_SS25_cbzo9o`}
          alt={header}
          width="100%"
        />
      </picture>
      <div>
        <div>
          <div className={styles.asosWorldIcon}>
            <AsosWorldLogo
              aria-label={translate(
                "loyalty_landing_page_accessibility_logo_description"
              )}
              role="img"
            />
          </div>
        </div>
        <div className={classNames(styles.connectContainer)}>
          <Decoration
            width="60"
            height="168"
            className={global.desktopAndTablet}
          />
          <Decoration width="32" height="210" className={global.mobileOnly} />
          <div className={classNames(styles.header, global.headerASOSWorld)}>
            <h1 className={global.textBackground} aria-label={header}>
              {headerFormatted}
            </h1>
          </div>
          <Decoration width="25" height="36" className={global.mobileOnly} />
          <div>
            <div
              className={classNames(
                global.leavesden1,
                styles.description,
                global.textBackground
              )}
            >
              {translate("loyalty_landing_page_intro_body")}
            </div>
            <Decoration
              width="525"
              height="36"
              className={global.desktopOnly}
            />
            <div
              className={classNames(
                styles.buttonLinksContainer,
                global.textBackground
              )}
            >
              <span className={styles.joinNow}>
                {currentTierId ? (
                  <ExploreBenefits
                    optedInButtonText={translate(
                      "loyalty_landing_page_intro_opted_in_button"
                    )}
                  />
                ) : (
                  <JoinNow
                    isAnonymous={isAnonymous}
                    optedOutButtonText={translate(
                      "loyalty_landing_page_intro_opted_out_button"
                    )}
                  />
                )}
              </span>
              <span className={styles.tsAndCs}>
                <TsAndCs
                  termsText={translate(
                    "loyalty_landing_page_into_terms_link_copy_web"
                  )}
                  privacyPolicyText={translate(
                    "loyalty_landing_page_intro_privacy_link_copy_web"
                  )}
                />
              </span>
              <button
                className={classNames(global.london3, styles.exploreFaqs)}
                onClick={scrollToNextSection}
              >
                {translate("loyalty_landing_page_intro_cta")}
              </button>
              <div className={styles.scrollToIcon}></div>
            </div>
            <Decoration
              width="332"
              height="24"
              className={global.desktopAndTablet}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

Connect.propTypes = {
  currentTierId: PropTypes.string,
  assetsUrl: PropTypes.string,
  isAnonymous: PropTypes.bool,
};

export default Connect;
